import React, { useState } from 'react';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { subnetCalculatorAPI, SubnetCalculationResult } from '../services/api';

const ITSubnetCalculator: React.FC = () => {
  const [cidr, setCidr] = useState('');
  const [result, setResult] = useState<SubnetCalculationResult | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleCalculate = async () => {
    if (!cidr.trim()) {
      setError('CIDR notacija je obavezna');
      setResult(null);
      return;
    }
    setLoading(true);
    setError('');
    try {
      const data = await subnetCalculatorAPI.calculate(cidr.trim());
      setResult(data);
    } catch (e: any) {
      // eslint-disable-next-line no-console
      console.error(e);
      setError(e?.response?.data?.error || 'Greška pri izračunavanju subnet-a');
      setResult(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4">
      <Card>
        <h2 className="mb-3">Subnet Kalkulator</h2>

        <div className="mb-3">
          <label className="block mb-1">CIDR Notacija</label>
          <InputText
            value={cidr}
            onChange={(e) => setCidr(e.target.value)}
            placeholder="npr. 172.16.10.0/16"
            style={{ width: '100%', maxWidth: '400px' }}
          />
        </div>

        <Button
          label="Izračunaj"
          icon="pi pi-calculator"
          onClick={handleCalculate}
          loading={loading}
        />

        {error && (
          <div className="mt-3">
            <Message severity="error" text={error} />
          </div>
        )}

        {result && (
          <div className="mt-4">
            <h3 className="mb-3">Rezultat kalkulacije:</h3>
            <div className="grid">
              <div className="col-12 md:col-6">
                <p>
                  <strong>Network Address:</strong> {result.networkAddress}
                </p>
                <p>
                  <strong>Broadcast Address:</strong> {result.broadcastAddress}
                </p>
                <p>
                  <strong>Subnet Mask:</strong> {result.subnetMask}
                </p>
              </div>
              <div className="col-12 md:col-6">
                <p>
                  <strong>Total IPs:</strong> {result.totalIPs}
                </p>
                <p>
                  <strong>Usable IPs:</strong> {result.usableIPs}
                </p>
                <p>
                  <strong>First Usable:</strong> {result.firstUsableIP}
                </p>
                <p>
                  <strong>Last Usable:</strong> {result.lastUsableIP}
                </p>
              </div>
            </div>

            <div className="mt-3">
              <Button
                label="Sačuvaj Subnet"
                icon="pi pi-save"
                severity="success"
                outlined
                disabled
              />
            </div>
          </div>
        )}
      </Card>
    </div>
  );
};

export default ITSubnetCalculator;






